import { Flex, Text, GridItem, Grid } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Assets
import "mapbox-gl/dist/mapbox-gl.css";
import { convertDateToFormattedString } from "config/functions";

export default function YourTransfers(props: {
  latitude: number;
  longitude: number;
  valor: any;
  data: any;
  nomeLinha: any;
  numeroLinha: any;
  numeroValidador: any;
}) {
  const { ...rest } = props;

  // Chakra color mode
  const center = {
    lat: rest.latitude,
    lng: rest.longitude,
  };

  const containerStyle = {
    width: "100%",
    height: "300px",
  };
  return (
    <Flex direction="column" align="start" w={"100%"} mt={"-25px"}>
      <Text color={"black"} fontSize="md" fontWeight="300">
        <b>Data:</b> {convertDateToFormattedString(rest.data)}
      </Text>
      {rest.numeroLinha && (
        <Text color={"black"} fontSize="md" fontWeight="300">
          <b>Linha:</b> {rest.numeroLinha} - {rest.nomeLinha}
        </Text>
      )}
      {rest.numeroValidador && (
        <Text color={"black"} fontSize="md" fontWeight="300">
          <b>Validador:</b> {rest.numeroValidador}
        </Text>
      )}

      <Grid templateColumns="repeat(2, 1fr)" gap={0}>
        <GridItem w="100%" h="5">
          <Text color={"black"} fontSize="md" fontWeight="300">
            <b>Valor:</b>
          </Text>
        </GridItem>
        <GridItem w="170%" h="5" ml={"-9px"}>
          {rest.valor}
        </GridItem>
      </Grid>
      <Card
        justifyContent="center"
        position="relative"
        flexDirection="row"
        w="100%"
        h="1000%"
        p="10px"
        zIndex="0"
        {...rest}
      >
        <LoadScript googleMapsApiKey="AIzaSyCdY9pOxve3qQO-lJM-_3ibACwcZ8fUQAY">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
          >
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      </Card>
    </Flex>
  );
}
